import { StatusBreakdownChart } from "../StatusBreakdownChart";
import type { AiProviderModelCostRow } from "./aiProviderMonitoring";
import { formatEstimatedCostUsd } from "./aiUsage";
import { buildModelSpendSegments } from "./modelSpendSegments";

type Props = {
  modelRows: readonly AiProviderModelCostRow[];
};

export function AiProviderModelSpendChart({ modelRows }: Props) {
  const { segments, total } = buildModelSpendSegments(modelRows);

  return (
    <StatusBreakdownChart
      title="Spend by model"
      total={total}
      segments={segments}
      formatValue={formatEstimatedCostUsd}
      embedded
      wrapLegend
      showLegendValue={false}
      placeholder={modelRows.length === 0}
    />
  );
}
